module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-2.cfff0b49.jpg";